// CUSTOM JS.
import { initLimitParagraphWidths } from './modules/limitParagraphWidths'
import { addIcons } from './modules/addIcons'
import { addButtonIcons } from './modules/addIcons'



// Add an optimized resize event.
(function() {
	var throttle = function(type, name, obj) {
		obj = obj || window;
		var running = false;
		var func = function() {
			if (running) { return; }
			running = true;
				requestAnimationFrame(function() {
					obj.dispatchEvent(new CustomEvent(name))
					running = false;
			});
		};
		obj.addEventListener(type, func)
	};

	throttle("resize", "optimizedResize")
})();
// Usage example: Recalculate on resize
// window.addEventListener("optimizedResize", function() {
// 	window.setTimeout( ()=>{
// 		console.log( 'optimized resize called!')
// 	}, 100)
// });






function filterSwapTotalResultText( post_type = 'vorming' ) {
	const filterTotalResultsCounter = document.querySelector(".wp-block-query-total");
	if (filterTotalResultsCounter) {
		// console.log( 'testing', post_type)

		// Vormingen or Cases?
		let labelSingular = "vorming";
		let labelPlural = "vormingen";
		if ('case' === post_type) {
			labelSingular = "case";
			labelPlural = "cases";
		}


		filterTotalResultsCounter.innerText = filterTotalResultsCounter.innerText.replace("resultaat", labelSingular);
		filterTotalResultsCounter.innerText = filterTotalResultsCounter.innerText.replace("resultaten", labelPlural);
		filterTotalResultsCounter.classList.add('updated-filter-result-txt');

		if ('0 vormingen gevonden' === filterTotalResultsCounter.innerText) {
			filterTotalResultsCounter.classList.add('no-results-found');
		} else if ('0 cases gevonden' === filterTotalResultsCounter.innerText) {
			filterTotalResultsCounter.classList.add('no-results-found');
		}
	}
}

function vormingenCollapseDetails() {
	// wp-block-details search-filter-query--filters
}

function vormingenFilterToggleFieldsets(vormingenWrapper, forceClose) {
	const vormingenFiltersCheckboxesFields = document.querySelectorAll('.wp-block-search-filter-choice-checkbox');

	const openCheckboxesFieldsIds = vormingenWrapper.dataset.openFieldIds

	if (vormingenFiltersCheckboxesFields) {
		vormingenFiltersCheckboxesFields.forEach(vormingenFiltersCheckboxesField => {
			const legend = vormingenFiltersCheckboxesField.querySelector('legend')
			const fieldset = vormingenFiltersCheckboxesField.querySelector('fieldset')

			if (legend) {
				legend.setAttribute('tabindex', 0)

				if (forceClose) {
					legend.classList.remove('open')
				}

				legend.addEventListener('keyup', function (e) {
					// ENTER key || arrow down || arrow up
					if (e.keyCode === 13 || e.keyCode === 40 || e.keyCode === 38) {
						event.currentTarget.click();
					}
				});

				legend.addEventListener('click', (event) => {
					// console.log(event.target)
					// console.log( event.currentTarget )
					if (event.currentTarget.classList.contains('open')) {
						event.currentTarget.classList.remove('open')
					} else {
						event.currentTarget.classList.add('open')
					}
				})
			}

			if (vormingenFiltersCheckboxesField.classList.contains('open')) {

			} else {

			}
		})
	}

}



function vormingenFilterLoaded() {

	// Since we can't filter the Post Count Block just yet, we'll do it the hacky way for now. On each set of results (because the block is reloaded each time). Default state:
	filterSwapTotalResultText( 'vorming' );

	const vormingenQueryId = 1;
	const vormingenWrapper = document.querySelector('.search-filter-query--id-' + vormingenQueryId);
	const vormingenQuery = window.searchAndFilter.frontend.queries.get(vormingenQueryId);
	// console.log(vormingenWrapper);

	if (vormingenQuery && vormingenWrapper) {
		// Inital state: closed checkbox fieldsets.
		// vormingenFilterToggleFieldsets( vormingenWrapper, true );

		// Disable checkboxes with no results (but keep showing them).
		// Docs: https://searchandfilter.com/documentation/developer/developer-queries/#h-detect-start-finish-of-fetching-results
		// Only hook in to the update if dynamic update is enabled for the query.
		if (vormingenQuery.getAttribute('resultsDynamicUpdate') === 'yes') {
			// Listen for the update to the results.
			// vormingenQuery.on('get-results/start', function (queryObject) {
			// 	console.log("Start getting results.");

			// 	// get all open checkboxes field IDs (so we can restore the open/collapsed state after the search).
			// 	const openCheckboxesFields = document.querySelectorAll('.wp-block-search-filter-choice-checkbox legend.open');
			// 	let openCheckboxesFieldsIds = new Array();
			// 	openCheckboxesFields.forEach(vormingenFiltersCheckboxesField => {
			// 		openCheckboxesFieldsIds.push(vormingenFiltersCheckboxesField.getAttribute('id'));


			// 		// vormingenWrapper.


			// 		// var retrieved_string = $("#storageElement").data('storeit');
			// 		// var retrieved_array = JSON.parse(retrieved_string);
			// 	})

			// 	console.log(openCheckboxesFieldsIds);
			// 	if (openCheckboxesFieldsIds.length > 0) {
			// 		// data-open-field-ids=
			// 		vormingenWrapper.dataset.openFieldIds = openCheckboxesFieldsIds;
			// 	}

			// });


			// First round (default state).
			// const vormingenFilterCheckboxes = document.querySelectorAll(".search-filter-input-checkbox");
			// if (vormingenFilterCheckboxes) {
			// 	vormingenFilterDisableCheckboxes(vormingenFilterCheckboxes);
			// }


			// Listen for the update to the results.
			vormingenQuery.on('get-results/finish', function (queryObject) {
				// console.log("Finished getting results.");

				// const vormingenFilterCheckboxes = document.querySelectorAll(".search-filter-input-checkbox");
				// if (vormingenFilterCheckboxes) {
				// 	vormingenFilterDisableCheckboxes(vormingenFilterCheckboxes);
				// }

				// Since we can't filter the Post Count Block just yet, we'll do it the hacky way for now. On each set of results (because the block is reloaded each time).
				filterSwapTotalResultText('vorming');

				// Re-add the button icons.
				const chevronButtons = document.querySelectorAll('.wp-block-button .wp-block-button__link, .wp-element-button, .is-style-as-buttons .wp-block-navigation-item__label, a.is-style-arrow-right')
				addButtonIcons(chevronButtons)

				// vormingenFilterToggleFieldsets(vormingenWrapper, false);

			});
		}

	}
}

function vormingenFilterDisableCheckboxes(vormingenFilterCheckboxes) {
	vormingenFilterCheckboxes.forEach(checkbox => {
		let countEl = checkbox.querySelector('.search-filter-input-checkbox__count');

		if (countEl) {
			// console.log(countEl.innerText);

			if ('(0)' === countEl.innerText) {
				// console.log('add disabled class');
				// console.log(checkbox.querySelector('input'));
				checkbox.querySelector('input').setAttribute('disabled', 'disabled');
				// add('search-filter-input-checkbox--no-results');
			} else {
				checkbox.classList.remove('search-filter-input-checkbox--no-results');
			}
		}
	});
}


// Cases filter.
function casesFilterLoaded() {
	// console.log('cases filter loaded');

	// Since we can't filter the Post Count Block just yet, we'll do it the hacky way for now. On each set of results (because the block is reloaded each time). Default state:
	filterSwapTotalResultText( 'case' );

	const casesQueryId = 2;
	const casesWrapper = document.querySelector('.search-filter-query--id-' + casesQueryId);
	const casesQuery = window.searchAndFilter.frontend.queries.get(casesQueryId);

	if (casesQuery && casesWrapper) {

		// Disable checkboxes with no results (but keep showing them).
		// Docs: https://searchandfilter.com/documentation/developer/developer-queries/#h-detect-start-finish-of-fetching-results
		// Only hook in to the update if dynamic update is enabled for the query.
		if (casesQuery.getAttribute('resultsDynamicUpdate') === 'yes') {

			// Listen for the update to the results.
			casesQuery.on('get-results/finish', function (queryObject) {

				// Since we can't filter the Post Count Block just yet, we'll do it the hacky way for now. On each set of results (because the block is reloaded each time).
				filterSwapTotalResultText('case');

				// Re-add the button icons.
				const chevronButtons = document.querySelectorAll('.wp-block-button .wp-block-button__link, .wp-element-button, .is-style-as-buttons .wp-block-navigation-item__label, a.is-style-arrow-right')
				addButtonIcons(chevronButtons)

			});
		}

	}
}



// Initial setup on Load.
// In order of need.
document.addEventListener('DOMContentLoaded', (event) => {
	// console.log( 'JS theme loaded. Cookiebot must not prohibit this.' )

	const html = document.querySelector('html');
	const body = document.querySelector('body');
	html.classList.remove('no-js')
	html.classList.add('js')


	// When the last child of #main .entry-content has a background, remove the top margin from the footer.
	const lastContentItem = document.querySelector('#main .entry-content > :last-child');
	const siteFooter = document.querySelector('footer.wp-block-template-part');
	if (lastContentItem && siteFooter) {
		if (lastContentItem.classList.contains('has-background')) {
			siteFooter.classList.add('no-margin-top');
		}
	}




	// Limit paragraph widths.
	initLimitParagraphWidths();

	// Update sniffs on resize. Calculated margins might have changed.
	window.addEventListener("optimizedResize", function () {
		initLimitParagraphWidths();
	});


	// Add the icons
	addIcons();




	// body.setAttribute('id', 'top');




	// const siteHeader = document.querySelector('.site-header')
	// const dropdownWg = document.querySelector('.menu-item__has-dropdown--wg .wp-block-navigation__submenu-container')
	// if (siteHeader && dropdownWg) {
	// 	// console.log('site header found')
	// 	// Revert styling to fullwidth dropdown.
	// 	siteHeader.classList.add('with-inzet-dropdown')

	// 	// Group items, based on .menu-item--label-only items
	// 	dropdownWg.classList.add('inzet-dropdown--wg')
	// 	let dropdownWgItems = siteHeader.querySelectorAll('.menu-item__has-dropdown--wg .wp-block-navigation__submenu-container > .wp-block-navigation-item')
	// 	if (dropdownWgItems) {
	// 		let currentSubgroupList = false
	// 		dropdownWgItems.forEach(element => {

	// 			// => make new list when you see a label
	// 			// => add new list as sublist to the label menu item
	// 			// // => move following li to this new list
	// 			if (element.classList.contains('menu-item--label-only')) {
	// 				// console.log( 'we have a new subgroup')
	// 				element.classList.add('inzet-grouped-menu-items__label')

	// 				let subgroupList = document.createElement('ul')
	// 				subgroupList.classList.add('inzet-grouped-menu-items')
	// 				element.append(subgroupList)
	// 				currentSubgroupList = subgroupList

	// 			} else if (currentSubgroupList) {
	// 				// console.log( 'we have a subgroup, add our item')
	// 				element.classList.add('inzet-grouped-menu-items__item')
	// 				element.remove()
	// 				currentSubgroupList.append(element)
	// 			}
	// 		})
	// 	}
	// }


	// console.log('A toggles?')
	// const menuToggleButtons = document.querySelectorAll('.wp-block-navigation-submenu__toggle')
	// if (siteHeader && menuToggleButtons) {
	// 	// console.log('B toggles!')
	// 	menuToggleButtons.forEach(element => {
	// 		element.addEventListener('touchend', (event) => {
	// 			// console.log('C toggle clicked')
	// 			// console.log(event.currentTarget)
	// 			// console.log( event.target.state.isMenuOpen)
	// 			if (event.currentTarget.hasAttribute("aria-expanded")) {
	// 				if ("true" === event.currentTarget.getAttribute("aria-expanded")) {
	// 					// console.log('close submenu')
	// 					event.currentTarget.setAttribute("aria-expanded", "false")
	// 				} else {
	// 					// console.log('open submenu')
	// 					event.currentTarget.setAttribute("aria-expanded", "true")

	// 					// set max height subnav.
	// 					// --inzet-header-height: 50vh;
	// 					siteHeader.style.setProperty("--inzet-header-height", siteHeader.offsetHeight + 'px')
	// 				}
	// 			}
	// 		})
	// 	})
	// }


	// Filters.
	// Only for the FRONT. This file should not be loaded in the admin, but test anyways.
	if (! html.classList.contains('block-editor-iframe__html')) {
		// console.log('load filter fixes')

		// Undocumented event listener 'search-filter/mount', provided via support email.
		// console.log('A');
		// If S&F already mounted before this script ran, set up immediately…
		const vormingenQueryId = 1;
		const casesQueryId = 2;

		// Open/close filter details element initially (when filtering: leave it open, that's the default).
		const filtersDetailsEl = document.querySelector('.wp-block-details.search-filter-query--filters');
		if (filtersDetailsEl && 601 > window.innerWidth) {
			filtersDetailsEl.removeAttribute('open');
		}

		if (window.searchAndFilter?.frontend?.queries?.get(vormingenQueryId)) {
			// console.log('A already mounted');
			vormingenFilterLoaded();
		} else {
			// …otherwise wait for the mount event.
			// console.log('A not yet mounted, add event listener');
			document.addEventListener('search-filter/mount', vormingenFilterLoaded);
		}

		if (window.searchAndFilter?.frontend?.queries?.get(casesQueryId)) {
			// console.log('A already mounted');
			casesFilterLoaded();
		} else {
			// …otherwise wait for the mount event.
			// console.log('A not yet mounted, add event listener');
			document.addEventListener('search-filter/mount', casesFilterLoaded);
		}
	}


})



